/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
import { push } from 'react-router-redux';
import moment from 'moment';
import uuidv4 from 'uuid/v4';
import { uniq } from 'lodash';
import { notification } from 'antd';
import { delay } from 'redux-saga';
import { put, takeLatest, select, call } from 'redux-saga/effects';
import { setNotification, operatorTyping, ADMIN_CUSTOMER_ID, ADMIN_CUSTOMER_TYPEOF } from 'utils';
import { loadBillingAccount } from '../actions/orderActions';
import * as CustomerActions from '../actions/customerActions';
import * as CustomerApi from '../api/customerApi';
import * as Macros from './macros';
import { getQuoteApi } from '../api/quoteApi';
import { getUsersApi } from '../api/userApi';
import { getConfigurationsMacro, getProductGroupsMacro } from './macros';
import * as CustomerTypes from '../types/customerTypes';

const getCustomer = state => state.customer;
const getLayout = state => state.layout;

// L O A D   E D I T A B L E   C U S T O M E R
export function* loadEditableCustomerSaga(action) {
    try {
        const paramCustomer = {
            filter: JSON.stringify({
                _id: action.id,
            }),
            joins: JSON.stringify(['contacts']),
        };

        const resultCustomer = yield CustomerApi.getCustomersApi(paramCustomer);

        if (resultCustomer.data.hits.length === 0) {
            notification.error({
                message: 'Error',
                description: 'Customer don\'t exist',
            });

            yield put(push('/404'));
            yield put(CustomerActions.loadCustomersErr());
        } else {
            const [customer] = resultCustomer.data.hits;

            if (customer.salesman_id) {
                const resultSales = yield getUsersApi({ filter: JSON.stringify({ _id: customer.salesman_id }) });
                const [salesman] = resultSales.data.hits;

                if (salesman) {
                    customer.salesman = `${salesman.first_name} ${salesman.last_name}`;
                }
            }

            yield put(CustomerActions.loadEditableCustomerRes(customer));
        }
    } catch (e) {
        yield put(CustomerActions.loadCustomersErr());
        console.log(e);
    }
}

export function* loadEditableCustomerWatcher() {
    yield takeLatest(CustomerTypes.LOAD_EDITABLE_CUSTOMER, loadEditableCustomerSaga);
}
// L O A D   E D I T A B L E   C U S T O M E R

// L O A D   C U S T O M E R   T U R N O V E R
export function* loadCustomerTurnoverSaga(action) {
    try {
        if (action.id && action.id !== 'undefined') {
            const result2Months = yield CustomerApi.getCustomerTurnoverApi(action.id, null, 'month');
            const resultTotal = yield CustomerApi.getCustomerTurnoverApi(action.id, null, 'all');

            if (result2Months.data.length === 0 || resultTotal.data.length === 0) {
                yield put(CustomerActions.loadCustomerTurnoverErr());
            } else {
                yield put(CustomerActions.loadCustomerTurnoverRes(result2Months.data, resultTotal.data));
            }
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadCustomerTurnoverErr());
    }
}

export function* loadCustomerTurnoverWatcher() {
    yield takeLatest(CustomerTypes.LOAD_CUSTOMER_TURNOVER, loadCustomerTurnoverSaga);
}
// L O A D   C U S T O M E R   T U R N O V E R

// A D D   N E W   C U S T O M E R
function* addNewCustomerSaga(action) {
    const { locale, reseller } = yield select(getLayout);
    const siteGroup = reseller.data.hits[0].site_group;
    const finalDescription = 'customers.notification.newCustomerAddedSuccess';

    try {
        const dataAccount = {
            customer_id: action.data.customer_id,
            site_group: action.data.site_group,
            customer_type: action.data.isCompany,
            is_reseller: action.data.isReseller,
            salesman_id: action.data.salesman_id,
            status: action.data.statusAccount,
            neutral_shipping: action.data.neutralShipping,
            priority_type: action.data.customerType === 'null' ? null : action.data.customerType,
            category: action.data.category,
        };

        if (action.data.companyName !== null) {
            dataAccount.company = action.data.companyName;
        }

        if (action.data.activitySector !== null) {
            dataAccount.activities = action.data.activitySector;
        }

        if (action.data.vatInformation !== null) {
            dataAccount.vat_information = action.data.vatInformation;
        }

        if (action.data.paymentDelay !== null) {
            dataAccount.payment_delay = action.data.freeOfCashPayment === false ? null : action.data.paymentDelay;
        }

        if (action.data.groupingInvoiceType !== null) {
            dataAccount.grouped_invoices_type = action.data.groupedInvoice === false ? null : action.data.groupingInvoiceType;
        }

        if (action.data.defaultShippingType !== null) {
            dataAccount.shipping_type_id = action.data.defaultShippingType;
        }

        const dataContact = {
            customer_id: action.data.customer_id,
            contact_id: action.contact.contact_id,
            contact_type: 'MAIN',
            job: 'RH',
            department: 'RH',
            gender: action.contact.gender,
            reseller_id: action.contact.reseller_id,
            first_name: action.contact.firstname,
            last_name: action.contact.lastname,
            email: action.contact.email,
            phone_number: action.contact.phone,
            language: action.contact.language,
            birthday: action.contact.date,
            password: action.contact.password,
            comment: action.contact.content,
        };

        const paramsEmail = {
            joins: JSON.stringify(['customer']),
        };

        const sendFilter = {
            email: action.contact.email,
            join: { 'customer.site_group': siteGroup },
        };

        paramsEmail.filter = JSON.stringify(sendFilter);
        const resultEmail = yield CustomerApi.getContactsApi(paramsEmail);

        if (resultEmail.data.length === 0 || resultEmail.data.hits.length === 0) {
            const result = yield CustomerApi.addNewCustomerApi(dataAccount);
            if (result.status === 202) {
                yield CustomerApi.addNewContactApi(dataContact);

                yield put(CustomerActions.addNewCustomerRes(true, false));
                yield put(push(`/crm/customers/view/${action.data.customer_id}`));

                yield put(CustomerActions.addNewCustomerRes(false, true));
                yield delay(1000);
                yield put(CustomerActions.addNewCustomerRes(false, false));

                yield call(loadCustomerTurnoverSaga, { id: action.data.customer_id });
                yield call(loadEditableCustomerSaga, { id: action.data.customer_id });

                setNotification('success', locale, 'global.success', finalDescription);
            } else {
                const error = yield result.json();

                setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
                yield put(CustomerActions.addNewCustomerErr(error.message));
            }
        } else {
            setNotification('error', locale, 'global.error', `The main contact with email ${action.contact.email} already exists!`);
            yield put(CustomerActions.addNewCustomerErr(true));
        }
    } catch (e) {
        setNotification('error', locale, 'global.error', 'customers.notification.addingNewCustomerError');
        yield put(CustomerActions.addNewCustomerErr());
        console.log(e);
    }
}

export function* addNewCustomerWatcher() {
    yield takeLatest(CustomerTypes.ADD_NEW_CUSTOMER, addNewCustomerSaga);
}
// A D D   N E W   C U S T O M E R

// L O A D   C U S T O M E R S
function* loadCustomersSaga() {
    try {
        const customer = yield select(getCustomer);
        const { admin } = yield select(getLayout);
        const { offset, limit, sort, filters } = customer;

        const params = {
            offset,
            limit,
            joins: JSON.stringify(['main_contact']),
        };

        const sendFilter = {};

        if (filters.customerID !== '') {
            sendFilter[ADMIN_CUSTOMER_ID[admin]] = ADMIN_CUSTOMER_TYPEOF[admin](filters.customerID);
        }

        if (filters.firstName !== '') {
            sendFilter.join = {
                'contacts.first_name': operatorTyping(filters.firstName),
            };
        }

        if (filters.lastName !== '') {
            sendFilter.join = {
                ...sendFilter.join,
                'contacts.last_name': operatorTyping(filters.lastName),
            };
        }

        if (filters.email !== '') {
            sendFilter.join = {
                ...sendFilter.join,
                'contacts.email': operatorTyping(filters.email),
            };
        }

        if (filters.lang !== undefined) {
            sendFilter.join = {
                ...sendFilter.join,
                'contacts.language': filters.lang,
            };
        }

        if (filters.customer_type !== undefined) {
            sendFilter.customer_type = filters.customer_type;
        }

        if (filters.b2b_login !== undefined) {
            sendFilter.join = {
                ...sendFilter.join,
                'contacts.b2b_login': filters.b2b_login,
            };
        }

        if (filters.company !== '') {
            sendFilter.company = operatorTyping(filters.company);
        }

        if (filters.vat !== '') {
            sendFilter.vat_information = operatorTyping(filters.vat);
        }

        if (filters.status !== undefined) {
            sendFilter.status = JSON.parse(filters.status);
        }

        params.filter = JSON.stringify(sendFilter);

        if (sort !== null) {
            params.sort_by = JSON.stringify({ created_at: sort.type === 'asc' ? 1 : -1 });
        }

        const result = yield CustomerApi.getCustomersApi(params);
        yield put(CustomerActions.loadCustomersRes(result.data));
    } catch (e) {
        yield put(CustomerActions.loadCustomersErr());
        console.log(e);
    }
}

export function* loadCustomersWatcher() {
    yield takeLatest(CustomerTypes.LOAD_CUSTOMERS, loadCustomersSaga);
}
// L O A D   C U S T O M E R S


// E D I T   C U S T O M E R
function* editCustomerSaga(action) {
    const layout = yield select(getLayout);
    const customer = yield select(getCustomer);
    const { locale } = layout;
    const { edit } = customer;
    const finalDescription = 'customers.notification.customerEditedSuccess';

    try {
        const dataAccount = {
            customer_id: action.data.customer_id,
            site_group: action.data.site_group,
            customer_type: action.data.isCompany,
            is_reseller: action.data.isReseller,
            salesman_id: action.data.salesman_id,
            status: action.data.statusAccount,
            neutral_shipping: action.data.neutralShipping,
            priority_type: action.data.customerType === 'null' ? null : action.data.customerType,
            category: action.data.category,
        };

        if (action.data.companyName !== null) {
            dataAccount.company = action.data.companyName;
        }

        if (action.data.activitySector !== null) {
            dataAccount.activities = action.data.activitySector;
        }

        if (action.data.vatInformation !== null) {
            dataAccount.vat_information = action.data.vatInformation;
        }

        if (action.data.paymentDelay !== null) {
            dataAccount.payment_delay = action.data.freeOfCashPayment === false ? null : action.data.paymentDelay;
        }

        if (action.data.groupingInvoiceType !== null) {
            dataAccount.grouped_invoices_type = action.data.groupedInvoice === false ? null : action.data.groupingInvoiceType;
        }

        if (action.data.defaultShippingType !== null) {
            dataAccount.shipping_type_id = action.data.defaultShippingType;
        }

        const dataContact = {
            customer_id: action.data.customer_id,
            contact_id: action.contact?.contact_id,
            contact_type: 'MAIN',
            job: 'RH',
            department: 'RH',
            gender: action.contact?.gender,
            reseller_id: action.contact?.reseller_id,
            first_name: action.contact?.firstname,
            last_name: action.contact?.lastname,
            email: action.contact?.email,
            phone_number: action.contact?.phone,
            language: action.contact?.language,
            birthday: action.contact?.date,
            password: action.contact?.password !== '' ? action.contact?.password : null,
            comment: action.contact?.content,
        };

        const result = yield CustomerApi.editCustomerApi(dataAccount);

        if (result.status === 202) {
            if (edit.data?.contacts.length === 0 || (!!edit.data?.contacts.find(c => c.contact_type !== 'MAIN') && !edit.data?.contacts.find(c => c.contact_type === 'MAIN'))) {
                CustomerApi.addNewContactApi(dataContact);
            } else if (process.env.REACT_APP_EDIT_MAIN_CONTACT_IN_CUSTOMER === 'true') {
                yield CustomerApi.editContactApi(dataContact);
            }

            yield put(CustomerActions.editCustomerRes(true, false));
            yield put(push(`/crm/customers/view/${action.data.customer_id}`));

            yield put(CustomerActions.editCustomerRes(true, true));
            yield delay(1000);
            yield put(CustomerActions.editCustomerRes(false, false));
            yield call(loadCustomerTurnoverSaga, { id: action.data.customer_id });
            yield call(loadEditableCustomerSaga, { id: action.data.customer_id });

            setNotification('success', locale, 'global.success', finalDescription);
        } else {
            const error = yield result.json();

            if (process.env.REACT_APP_EDIT_MAIN_CONTACT_IN_CUSTOMER === 'true') {
                const resultContact = yield CustomerApi.editContactApi(dataContact);
                const errorContact = yield resultContact.json();

                if (error.message) {
                    setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
                    yield put(CustomerActions.editCustomerErr(error.message));
                } else if (errorContact.message) {
                    setNotification('error', locale, 'global.error', errorContact.message, { noTranslateMsg: true });
                    yield put(CustomerActions.editCustomerErr(errorContact.message));
                }
            } else {
                setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
                yield put(CustomerActions.editCustomerErr(error.message));
            }
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.editCustomerErr());
        setNotification('error', locale, 'global.error', 'customers.notification.editedCustomerError');
    }
}

export function* editCustomerWatcher() {
    yield takeLatest(CustomerTypes.EDIT_CUSTOMER, editCustomerSaga);
}
// E D I T   C U S T O M E R

// L O A D   C O N T A C T S
function* loadContactsSaga(action) {
    try {
        const customer = yield select(getCustomer);
        const { offset, limit } = customer.contacts;

        const sendFilters = {
            customer_id: action.id,
        };

        if (customer.contacts.filters.status !== null) {
            sendFilters.status = customer.contacts.filters.status;
        }

        const params = {
            filter: JSON.stringify(sendFilters),
            offset,
            limit,
        };
        params.sort_by = JSON.stringify({ created_at: -1 });

        const result = yield CustomerApi.getContactsApi(params);
        if (result.data.length === 0) {
            notification.error({
                message: 'Error',
                description: 'Contact don\'t exist',
            });

            yield put(push('/404'));
            yield put(CustomerActions.loadContactsErr());
        } else {
            yield put(CustomerActions.loadContactsRes(result.data));
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadContactsErr());
    }
}

export function* loadContactsWatcher() {
    yield takeLatest(CustomerTypes.LOAD_CONTACTS, loadContactsSaga);
}
// L O A D   C O N T A C T S

// A D D   N E W   C O N T A C T
function* addNewContactSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const finalDescription = 'customers.notification.newContactAddedSuccess';
    const idCustomer = action.data.customer_id;

    try {
        const dataContact = {
            customer_id: action.data.customer_id,
            contact_id: action.data.contact_id,
            reseller_id: action.data.reseller_id,
            job: 'RH',
            department: 'DIRECTION',
            gender: action.data.gender,
            first_name: action.data.firstname,
            last_name: action.data.lastname,
            email: action.data.email,
            phone_number: action.data.phone,
            language: action.data.language,
            contact_type: action.data.contactType,
            birthday: action.data.date,
            password: action.data.password,
            comment: action.data.content,
            status: action.data.statusContact,
        };

        const result = yield CustomerApi.addNewContactApi(dataContact);
        if (result.status === 202) {
            yield put(CustomerActions.addNewContactRes(true, false));

            if (!action.data.isPopup) {
                yield put(push(`/crm/customers/view/${idCustomer}`));
            }

            yield put(CustomerActions.addNewContactRes(false, true));
            yield delay(1000);
            yield put(CustomerActions.addNewContactRes(false, false));
            yield call(loadContactsSaga, { id: action.data.customer_id });

            setNotification('success', locale, 'global.success', finalDescription);
        } else {
            const error = yield result.json();

            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(CustomerActions.addNewContactErr(error.message));
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'customers.notification.addingNewContactError');
        yield put(CustomerActions.addNewContactErr());
    }
}

export function* addNewContactWatcher() {
    yield takeLatest(CustomerTypes.ADD_NEW_CONTACT, addNewContactSaga);
}
// A D D   N E W   C O N T A C T

// E D I T   C O N T A C T
function* editTableContactSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const finalDescription = 'customers.notification.contactEditedSuccess';
    const idCustomer = action.data.customer_id;

    try {
        const dataContact = {
            customer_id: action.data.customer_id,
            contact_id: action.data.contact_id,
            reseller_id: action.data.reseller_id,
            job: 'RH',
            department: 'DIRECTION',
            gender: action.data.gender,
            first_name: action.data.firstname,
            last_name: action.data.lastname,
            email: action.data.email,
            phone_number: action.data.phone,
            language: action.data.language,
            contact_type: action.data.contactType,
            birthday: action.data.date,
            password: action.password !== '' ? action.data.password : null,
            comment: action.data.content,
            status: action.data.statusContact,
            send_invoice: action.data.send_invoice,
            send_order: action.data.send_order,
            send_quotation: action.data.send_quotation,
            send_transport: action.data.send_transport,
        };

        const result = yield CustomerApi.editContactApi(dataContact);
        if (result.status === 202) {
            yield put(CustomerActions.editContactRes(true, false));
            yield put(push(`/crm/customers/view/${idCustomer}`));

            yield put(CustomerActions.editContactRes(true, true));
            yield delay(1000);
            yield put(CustomerActions.editContactRes(false, false));
            yield call(loadContactsSaga, { id: action.data.customer_id });

            setNotification('success', locale, 'global.success', finalDescription);
        } else {
            const error = yield result.json();

            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(CustomerActions.editContactErr(error.message));
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.editContactErr());
        setNotification('error', locale, 'global.error', 'customers.notification.editedContactError');
    }
}

export function* editTableContactWatcher() {
    yield takeLatest(CustomerTypes.EDIT_CONTACT, editTableContactSaga);
}
// E D I T   C O N T A C T

// A D D   C U S T O M E R   A D D R E S S
function* addNewAddressSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield CustomerApi.addNewAddressApi(action.data);
        if (result.status === 202) {
            yield put(CustomerActions.addNewAddressRes(true, false));
            yield put(CustomerActions.addNewAddressRes(false, true));
            yield delay(1000);
            yield put(CustomerActions.addNewAddressRes(false, false));

            setNotification('success', locale, 'global.success', 'customers.notification.addNewAddressSuccess');

            if (action.data.type === 'SHIPPING') {
                yield put({ type: CustomerTypes.LOAD_SHIPPING_ADDRESSES, customerId: action.data.customer_id });
            }

            if (action.data.type === 'BILLING_ACCOUNT') {
                yield put({ type: CustomerTypes.LOAD_BILLING_ADDRESSES, customerId: action.data.customer_id });
            }
        } else {
            const error = yield result.json();

            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(CustomerActions.addNewAddressErr(error.message));
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'customers.notification.addNewAddressError');
        yield put(CustomerActions.addNewAddressErr());
    }
}

export function* addNewAddressWatcher() {
    yield takeLatest(CustomerTypes.ADD_NEW_ADDRESS, addNewAddressSaga);
}
// A D D   C U S T O M E R   A D D R E S S

// L O A D   S H I P P I N G   A D D R E S S E S
export function* loadShippingAddressesSaga(action) {
    try {
        const customer = yield select(getCustomer);
        const { offset, limit, filters } = customer.addresses.shipping;
        const params = {
            filter: {
                customer_id: action?.customerId,
                type: 'SHIPPING',
            },
            offset,
            limit: 'setLimit' in action ? action.setLimit : limit,
        };

        if (filters.name !== '') {
            params.filter.name = {
                operator: 'typing',
                value: filters.name,
            };
        }

        if (filters.company !== '') {
            params.filter.company = {
                operator: 'typing',
                value: filters.company,
            };
        }

        if (filters.email !== '') {
            params.filter.email = {
                operator: 'typing',
                value: filters.email,
            };
        }

        if (filters.address_status !== '') {
            params.filter.address_status = filters.address_status;
        }

        params.filter = JSON.stringify(params.filter);
        params.sort_by = JSON.stringify({ created_at: -1 });
        const result = yield CustomerApi.getAddressesApi(params);

        if (result.status === 200) {
            yield put(CustomerActions.loadShippingAddressesRes(result.data));
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadShippingAddressesErr());
    }
}

export function* loadShippingAddressesWatcher() {
    yield takeLatest(CustomerTypes.LOAD_SHIPPING_ADDRESSES, loadShippingAddressesSaga);
}
// L O A D   S H I P P I N G   A D D R E S S E S

// L O A D   B I L L I N G   A D D R E S S E S
function* loadBillingAddressesSaga(action) {
    try {
        const customer = yield select(getCustomer);
        const { offset, limit, filters } = customer.addresses.billing;
        const params = {
            filter: {
                customer_id: action.customerId,
                type: 'BILLING_ACCOUNT',
            },
            offset,
            limit,
        };

        if (filters.name !== '') {
            params.filter.name = {
                operator: 'typing',
                value: filters.name,
            };
        }

        if (filters.company !== '') {
            params.filter.company = {
                operator: 'typing',
                value: filters.company,
            };
        }

        if (filters.vat_number !== '') {
            params.filter.vat_number = {
                operator: 'typing',
                value: filters.vat_number,
            };
        }

        if (filters.address_status !== '') {
            params.filter.address_status = filters.address_status;
        }

        params.filter = JSON.stringify(params.filter);
        params.sort_by = JSON.stringify({ created_at: -1 });
        const result = yield CustomerApi.getAddressesApi(params);

        if (result.status === 200) {
            yield put(CustomerActions.loadBillingAddressesRes(result.data));
            yield put(loadBillingAccount());
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadBillingAddressesErr());
    }
}

export function* loadBillingAddressesWatcher() {
    yield takeLatest(CustomerTypes.LOAD_BILLING_ADDRESSES, loadBillingAddressesSaga);
}
// L O A D   B I L L I N G   A D D R E S S E S

// S E T   D I S A B L E   S H I P P I N G   A D D R E S S
function* setDisableShippingAddressSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const params = {
            address_id: action.key,
            address_status: action.value ? 'ENABLED' : 'DISABLED',
        };

        const result = yield CustomerApi.enableDisableAddressApi(params);
        if (result.status === 202) {
            yield put(CustomerActions.setDisableShippingAddressRes(result.data));
        } else {
            setNotification('error', locale, 'global.error', 'segment.notification.disableSegmentError');
            yield put(CustomerActions.loadShippingAddressesErr());
        }
        yield put({ type: CustomerTypes.LOAD_SHIPPING_ADDRESSES, customerId: action.customerId });
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadShippingAddressesErr());
    }
}

export function* setDisableShippingAddressWatcher() {
    yield takeLatest(CustomerTypes.SET_DISABLE_SHIPPING_ADDRESS, setDisableShippingAddressSaga);
}
// S E T   D I S A B L E  S H I P P I N G    A D D R E S S

// S E T   D I S A B L E   B I L L I N G   A D D R E S S
function* setDisableBillingAddressSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const params = {
            address_id: action.key,
            address_status: action.value ? 'ENABLED' : 'DISABLED',
        };

        const result = yield CustomerApi.enableDisableAddressApi(params);
        if (result.status === 202) {
            yield put(CustomerActions.setDisableBillingAddressRes(result.data));
        } else {
            setNotification('error', locale, 'global.error', 'segment.notification.disableSegmentError');
            yield put(CustomerActions.loadBillingAddressesErr());
        }
        yield put({ type: CustomerTypes.LOAD_BILLING_ADDRESSES, customerId: action.customerId });
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadBillingAddressesErr());
    }
}

export function* setDisableBillingAddressWatcher() {
    yield takeLatest(CustomerTypes.SET_DISABLE_BILLING_ADDRESS, setDisableBillingAddressSaga);
}
// S E T   D I S A B L E  B I L L I N G    A D D R E S S

// E D I T   A D D R E S S
function* editAddressSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield CustomerApi.editAddressApi(action.data);

        if (result.status === 202) {
            yield put(CustomerActions.editAddressRes(true, false));

            yield put(CustomerActions.editAddressRes(true, true));
            yield delay(1000);
            yield put(CustomerActions.editAddressRes(false, false));

            setNotification('success', locale, 'global.success', 'customers.notification.editAddressSuccess');

            if (action.data.type === 'SHIPPING') { yield put({ type: CustomerTypes.LOAD_SHIPPING_ADDRESSES, customerId: action.data.customer_id }); }
            if (action.data.type === 'BILLING_ACCOUNT') { yield put({ type: CustomerTypes.LOAD_BILLING_ADDRESSES, customerId: action.data.customer_id }); }
        } else {
            const error = yield result.json();

            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(CustomerActions.editAddressErr(error.message));
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.editAddressErr());
        setNotification('error', locale, 'global.error', 'customers.notification.editAddressError');
    }
}

export function* editAddressWatcher() {
    yield takeLatest(CustomerTypes.EDIT_ADDRESS, editAddressSaga);
}
// E D I T   A D D R E S S

// D E L E T E   A D D R E S S
function* deleteAddressSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const params = {
            address_id: action.value,
        };
        const result = yield CustomerApi.deleteAddressApi(params);
        if (result.status === 202) {
            yield put(CustomerActions.deleteAddressRes(result.data));
            setNotification('success', locale, 'global.success', 'customers.notification.deleteAddressSuccess');
        } else {
            setNotification('error', locale, 'global.error', 'customers.notification.deleteAddressError');
            yield put(CustomerActions.loadShippingAddressesErr());
        }
        yield put({ type: CustomerTypes.LOAD_SHIPPING_ADDRESSES, customerId: action.customerId });
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadShippingAddressesErr());
    }
}

export function* deleteAddressWatcher() {
    yield takeLatest(CustomerTypes.DELETE_ADDRESS, deleteAddressSaga);
}
// D E L E T E   A D D R E S S

// L O A D   C U S T O M E R   O R D E R S
function* loadCustomerOrdersSaga(action) {
    try {
        const customer = yield select(getCustomer);
        const { offset, limit, filters, sort } = customer.orders;

        let configurationIDS = [];
        let productGroupIDS = [];

        const params = {
            filter: {
                customer_id: action.customerId,
            },
            offset,
            limit,
        };

        if (filters.status !== '') {
            params.filter.status = filters.status;
        }

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;
            params.sort_by = JSON.stringify({ created_at: sortInt });
        }

        params.filter = JSON.stringify(params.filter);

        const result = yield CustomerApi.getOrdersApi(params);

        if (result.status === 200) {
            const orders = result.data.hits;

            yield put(CustomerActions.loadCustomerOrdersRes(result.data, {}));

            orders.forEach((order) => {
                order.items.forEach((item) => {
                    productGroupIDS.push(item.product_group_id);

                    (item.configurations || []).forEach((configuration) => {
                        configurationIDS.push(configuration.configuration_id);
                    });
                });
            });

            configurationIDS = uniq(configurationIDS);
            productGroupIDS = uniq(productGroupIDS);

            const macroConfigurations = yield getConfigurationsMacro(configurationIDS);
            const macroProductGroups = yield getProductGroupsMacro(productGroupIDS);

            const configurations = macroConfigurations.data.hits;
            const productGroups = macroProductGroups.data.hits;

            yield put(CustomerActions.loadCustomerOrdersRes(result.data, {
                configurations,
                productGroups,
            }));
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadCustomerOrdersErr());
    }
}

export function* loadCustomerOrdersWatcher() {
    yield takeLatest(CustomerTypes.LOAD_CUSTOMER_ORDERS, loadCustomerOrdersSaga);
}
// L O A D   C U S T O M E R   O R D E R S

// L O A D   C U S T O M E R   Q U O T E S
function* loadCustomerQuotesSaga(action) {
    try {
        const customer = yield select(getCustomer);
        const { offset, limit, filters, sort } = customer.quotes;

        const params = {
            filter: {
                customer_id: action.customerId,
            },
            offset,
            limit,
        };

        if (filters.status !== undefined && filters.status !== '') {
            if (filters.status === 'EXPIRED') {
                params.filter.status = 'CREATED';
            } else {
                params.filter.status = filters.status;
            }
        }

        if (filters.title !== undefined && filters.title !== '') {
            params.filter.title = {
                operator: 'typing',
                value: filters.title,
            };
        }

        if (filters.contact !== undefined && filters.contact !== '') {
            params.filter.contact_id = filters.contact;
        }

        if (filters.sender !== undefined && filters.sender !== '') {
            params.filter.sales_man_id = filters.sender;
        }

        if (filters.start_date !== undefined && filters.start_date.length > 0) {
            params.filter.created_at = { between: filters.start_date };
        }

        if (filters.end_date !== undefined && filters.end_date.length > 0) {
            params.filter.expiration_date = { between: filters.end_date };
        }


        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;
            params.sort_by = JSON.stringify({ created_at: sortInt });
        }

        params.filter = JSON.stringify(params.filter);

        const result = yield getQuoteApi(params);
        let resultData = result.data;

        if (result.status === 200) {
            if (filters.status && filters.status === 'EXPIRED') {
                resultData = result.data.hits.filter(c => moment() > moment(c.expiration_date.$date));
            } else if (filters.status && filters.status === 'CREATED') {
                resultData = result.data.hits.filter(c => moment() < moment(c.expiration_date.$date));
            }

            if (filters.status && (filters.status === 'EXPIRED' || filters.status === 'CREATED')) {
                resultData = {
                    hits: resultData,
                    total: resultData.length,
                };
            }
            yield put(CustomerActions.loadCustomerQuotesRes(resultData));
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadCustomerQuotesErr());
    }
}

export function* loadCustomerQuotesWatcher() {
    yield takeLatest(CustomerTypes.LOAD_CUSTOMER_QUOTES, loadCustomerQuotesSaga);
}
// L O A D   C U S T O M E R   Q U O T E S

// L O A D   C U S T O M E R   Q U O T E S   C O N T A C T   &   S E N D E R
function* loadCustomerQuotesSenderSaga(action) {
    try {
        let senderIDS = [];
        if (action.quoteData.length > 0) {
            action.quoteData.forEach((hit) => {
                senderIDS.push(hit.sales_man_id);
            });
        }
        senderIDS = uniq(senderIDS);
        const resultSender = yield getUsersApi({ filter: JSON.stringify({ _id: senderIDS }) });
        if (resultSender.status === 200) {
            yield put(CustomerActions.loadCustomerQuotesSenderRes(resultSender.data));
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadCustomerQuotesSenderErr());
    }
}
function* loadCustomerQuotesContactSaga(action) {
    try {
        const result = yield getQuoteApi({
            filter: JSON.stringify({ customer_id: action.customerId }),
            limit: 999,
        });

        let contactIDS = [];
        if (result.status === 200) {
            if (result.data.hits.length > 0) {
                result.data.hits.forEach((hit) => {
                    contactIDS.push(hit.contact_id);
                });
            }

            contactIDS = uniq(contactIDS);
            const resultContact = yield CustomerApi.getContactsApi({ filter: JSON.stringify({ _id: contactIDS }) });
            if (resultContact.status === 200) {
                yield call(loadCustomerQuotesSenderSaga, { quoteData: result.data.hits });
                yield put(CustomerActions.loadCustomerQuotesContactRes(resultContact.data));
            }
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadCustomerQuotesContactErr());
    }
}

export function* loadCustomerQuotesContactWatcher() {
    yield takeLatest(CustomerTypes.LOAD_CUSTOMER_QUOTES_CONTACT, loadCustomerQuotesContactSaga);
}
// L O A D   C U S T O M E R   Q U O T E S   C O N T A C T   &   S E N D E R

// L O A D   C U S T O M E R   I N V O I C E S
function* loadCustomerInvoicesSaga(action) {
    try {
        const customer = yield select(getCustomer);
        const { offset, limit, filters } = customer.finance.invoices;

        const params = {
            filter: {
                customer_id: action.customerId,
                invoice_type: ['INVOICE', 'CREDIT_NOTE'],
            },
            offset,
            limit,
        };

        if (filters.id !== undefined && filters.id !== '') {
            params.filter['invoice_number.invoice_number_alias'] = filters.id;
        }

        if (filters.orderId !== undefined && filters.orderId !== '') {
            params.filter.order_number = filters.orderId;
        }

        if (filters.vat !== undefined && filters.vat !== '') {
            params.filter.invoice_account_vat_number = filters.vat;
        }

        if (filters.reference !== undefined && filters.reference !== '') {
            params.filter.customer_reference = {
                operator: 'typing',
                value: filters.reference,
            };
        }

        if (filters.ogm !== undefined && filters.ogm !== '') {
            params.filter.ogm = filters.ogm;
        }

        if (filters.status !== undefined && filters.status !== '') {
            params.filter.payment_status = filters.status;
        }

        if (filters.creationDate !== undefined && filters.creationDate.length > 0) {
            params.filter.created_at = { between: filters.creationDate };
        }

        if (filters.paymentDelay !== undefined && filters.paymentDelay.length > 0) {
            params.filter.expiration_date = { between: filters.paymentDelay };
        }

        params.filter = JSON.stringify(params.filter);
        params.sort_by = JSON.stringify({ created_at: -1 });
        const result = yield CustomerApi.getCustomerInvoicesApi(params);

        if (result.status === 200) {
            yield put(CustomerActions.loadCustomerInvoicesRes(result.data));
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadCustomerInvoicesErr());
    }
}

export function* loadCustomerInvoicesWatcher() {
    yield takeLatest(CustomerTypes.LOAD_CUSTOMER_INVOICES, loadCustomerInvoicesSaga);
}
// L O A D   C U S T O M E R   I N V O I C E S

// L O A D   C U S T O M E R   P R O F O R M A
function* loadCustomerProformaSaga(action) {
    try {
        const customer = yield select(getCustomer);
        const { offset, limit, filters } = customer.finance.proforma;

        const params = {
            filter: {
                customer_id: action.customerId,
                invoice_type: 'PROFORMA',
            },
            offset,
            limit,
        };

        if (filters.id !== undefined && filters.id !== '') {
            params.filter['invoice_number.invoice_number_alias'] = filters.id;
        }

        if (filters.orderId !== undefined && filters.orderId !== '') {
            params.filter.order_number = filters.orderId;
        }

        if (filters.vat !== undefined && filters.vat !== '') {
            params.filter.invoice_account_vat_number = filters.vat;
        }

        if (filters.reference !== undefined && filters.reference !== '') {
            params.filter.customer_reference = {
                operator: 'typing',
                value: filters.reference,
            };
        }

        if (filters.ogm !== undefined && filters.ogm !== '') {
            params.filter.ogm = filters.ogm;
        }

        if (filters.billing !== undefined) {
            params.filter.external_account_id = filters.billing;
        }

        if (filters.creationDate !== undefined && filters.creationDate.length > 0) {
            params.filter.created_at = { between: filters.creationDate };
        }

        // if (filters.paymentDelay !== undefined && filters.paymentDelay.length > 0) {
        //     params.filter.expiration_date = { between: filters.paymentDelay };
        // }

        params.filter = JSON.stringify(params.filter);
        params.sort_by = JSON.stringify({ created_at: -1 });

        const result = yield CustomerApi.getCustomerInvoicesApi(params);

        let orderStatus = [];

        if (result.status === 200) {
            const proforma = result.data.hits;

            proforma.forEach((p) => {
                if (p.order_id) {
                    orderStatus.push(p.order_id);
                }
            });

            orderStatus = uniq(orderStatus);

            const macroOrders = yield Macros.getOrderMacro(orderStatus);
            const orders = macroOrders?.data?.hits || [];

            result.data.hits = proforma.map((p) => {
                const order = orders.find(o => o._id === p.order_id);
                return {
                    ...p,
                    orderStatus: order?.status,
                };
            });

            yield put(CustomerActions.loadCustomerProformaRes(result.data));
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadCustomerProformaErr());
    }
}

export function* loadCustomerProformaWatcher() {
    yield takeLatest(CustomerTypes.LOAD_CUSTOMER_PROFORMA, loadCustomerProformaSaga);
}
// L O A D   C U S T O M E R   P R O F O R M A

// L O A D   B I L L I N G   A D D R E S S   F O R   F I N A N C E
function* loadBillingAddressForFinanceSaga(action) {
    try {
        const params = {
            filter: {
                _id: action.id,
            },
            offset: 0,
            limit: 10,
        };

        params.filter = JSON.stringify(params.filter);
        params.sort_by = JSON.stringify({ created_at: -1 });
        const result = yield CustomerApi.getAddressesApi(params);

        if (result.status === 200) {
            yield put(CustomerActions.loadBillingAddressForFinanceRes(result.data));
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadBillingAddressForFinanceErr());
    }
}

export function* loadBillingAddressForFinanceWatcher() {
    yield takeLatest(CustomerTypes.LOAD_BILLING_ADDRESS_FOR_FINANCE, loadBillingAddressForFinanceSaga);
}
// L O A D   B I L L I N G   A D D R E S S   F O R   F I N A N C E

// A D D   N E W   I N V O I C E
function* addInvoiceDetailSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield CustomerApi.addInvoiceDetailApi(action.product);
        if (result.status !== 202) {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.addNewInvoiceErr());
    }
}
function* addNewInvoiceSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield CustomerApi.addNewInvoiceApi(action.invoice);
        if (result.status === 202) {
            for (let i = 0; i < action.products.length; i += 1) {
                const product = {
                    invoice_id: action.invoice.invoice_id,
                    invoice_detail_product: action.products[i].product,
                    invoice_detail_quantity: action.products[i].quantity,
                    invoice_detail_discount: action.products[i].discount / 100,
                    invoice_detail_unit_amount: action.products[i].unitAmount,
                    invoice_detail_vat: action.products[i].vatRate / 100,
                    //  invoice_detail_amount: action.products[i].subtotal,
                    invoice_detail_comment: '',
                };
                yield call(addInvoiceDetailSaga, {
                    product,
                    invoiceId: action.invoice.invoice_id,
                    productsLength: action.products.length,
                    index: i,
                });
            }
            yield put(CustomerActions.addNewInvoiceRes(true, false));
            yield put(CustomerActions.addNewInvoiceRes(false, true));
            yield delay(1000);
            yield put(CustomerActions.addNewInvoiceRes(false, false));
            yield CustomerApi.markInvoiceAsDoneApi({ invoice_id: action.invoice.invoice_id });

            setNotification('success', locale, 'global.success', 'customers.notification.addNewInvoiceSuccess');
            yield put({ type: CustomerTypes.LOAD_CUSTOMER_INVOICES, customerId: action.invoice.customer_id });
            yield put({ type: CustomerTypes.LOAD_CUSTOMER_PROFORMA, customerId: action.invoice.customer_id });
        } else {
            const error = yield result.json();

            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(CustomerActions.addNewInvoiceErr(error.message));
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.addNewInvoiceErr());
    }
}

export function* addNewInvoiceWatcher() {
    yield takeLatest(CustomerTypes.ADD_NEW_INVOICE, addNewInvoiceSaga);
}
// A D D   N E W   I N V O I C E

// L O A D    I N V O I C E   D E T A I L S
function* loadInvoiceDetailsSaga(action) {
    try {
        const params = {
            filter: {
                id: action.invoiceId,
            },
            offset: 0,
            limit: 999,
        };

        params.filter = JSON.stringify(params.filter);
        params.sort_by = JSON.stringify({ created_at: -1 });
        const result = yield CustomerApi.getCustomerInvoicesApi(params);

        if (result.status === 200) {
            yield put(CustomerActions.loadInvoiceDetailsRes(result.data));
        }
    } catch (e) {
        console.log(e);
        yield put(CustomerActions.loadInvoiceDetailsErr());
    }
}

export function* loadInvoiceDetailsWatcher() {
    yield takeLatest(CustomerTypes.LOAD_INVOICE_DETAILS, loadInvoiceDetailsSaga);
}
// L O A D    I N V O I C E   D E T A I L S


// D O W N L O A D   A L L   I N V O I C E S
function* checkInvoicesFile(exportId, action, count = 0) {
    const paramsDownload = {
        filter: {
            id: exportId,
        },
    };
    paramsDownload.filter = JSON.stringify(paramsDownload.filter);
    const resultDownload = yield CustomerApi.getDownloadAllInvoicesApi(paramsDownload);
    if (resultDownload.status === 200) {
        const [invoicesFile] = resultDownload.data.hits;

        if (invoicesFile?.file !== null) {
            yield put(CustomerActions.downloadAllInvoicesRes(true, false, action.invoiceType, action.invoiceAction));
            yield put(CustomerActions.downloadAllInvoicesRes(false, true, action.invoiceType, action.invoiceAction));
            yield delay(1000);
            yield put(CustomerActions.downloadAllInvoicesRes(false, false, action.invoiceType, action.invoiceAction));

            const link = document.createElement('a');
            link.href = invoicesFile.file;
            link.download = true;
            link.click();
        } else if (invoicesFile?.status === 'CREATED' && count < 5) {
            const recount = count + 1;
            yield delay(3000);
            yield checkInvoicesFile(exportId, action, recount);
        } else {
            yield put(CustomerActions.downloadAllInvoicesErr(true, action.invoiceType, action.invoiceAction));
        }
    }
}

function* downloadAllInvoicesSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const customer = yield select(getCustomer);
        const invoicesFilters = customer.finance.invoices.filters;
        const proformaFilters = customer.finance.proforma.filters;

        const params = {
            export_id: uuidv4(),
            type: action.invoiceAction === 'download' ? 'INVOICE_PDF' : 'INVOICE_CSV',
            filter: {
                customer_id: action.data || undefined,
                invoice_type: action.invoiceType === 'invoices' ? ['INVOICE', 'CREDIT_NOTE'] : 'PROFORMA',
            },
            sort: [],
        };

        if (action.invoiceType === 'invoices') {
            if (invoicesFilters.id !== undefined && invoicesFilters.id !== '') {
                params.filter['invoice_number.invoice_number_alias'] = invoicesFilters.id;
            }

            if (invoicesFilters.orderId !== undefined && invoicesFilters.orderId !== '') {
                params.filter.order_number = invoicesFilters.orderId;
            }

            if (invoicesFilters.vat !== undefined && invoicesFilters.vat !== '') {
                params.filter.invoice_account_vat_number = invoicesFilters.vat;
            }

            if (invoicesFilters.reference !== undefined && invoicesFilters.reference !== '') {
                params.filter.customer_reference = {
                    operator: 'typing',
                    value: invoicesFilters.reference,
                };
            }

            if (invoicesFilters.ogm !== undefined && invoicesFilters.ogm !== '') {
                params.filter.ogm = invoicesFilters.ogm;
            }

            if (invoicesFilters.status !== undefined && invoicesFilters.status !== '') {
                params.filter.payment_status = invoicesFilters.status;
            }

            if (invoicesFilters.creationDate !== undefined && invoicesFilters.creationDate.length > 0) {
                params.filter.created_at = { between: invoicesFilters.creationDate };
            }

            if (invoicesFilters.paymentDelay !== undefined && invoicesFilters.paymentDelay.length > 0) {
                params.filter.expiration_date = { between: invoicesFilters.paymentDelay };
            }
        } else {
            if (proformaFilters.id !== undefined && proformaFilters.id !== '') {
                params.filter['invoice_number.invoice_number_alias'] = proformaFilters.id;
            }

            if (proformaFilters.orderId !== undefined && proformaFilters.orderId !== '') {
                params.filter.order_number = proformaFilters.orderId;
            }

            if (proformaFilters.vat !== undefined && proformaFilters.vat !== '') {
                params.filter.invoice_account_vat_number = proformaFilters.vat;
            }

            if (proformaFilters.reference !== undefined && proformaFilters.reference !== '') {
                params.filter.customer_reference = {
                    operator: 'typing',
                    value: proformaFilters.reference,
                };
            }

            if (proformaFilters.ogm !== undefined && proformaFilters.ogm !== '') {
                params.filter.ogm = proformaFilters.ogm;
            }

            if (proformaFilters.creationDate !== undefined && proformaFilters.creationDate.length > 0) {
                params.filter.created_at = { between: proformaFilters.creationDate };
            }

            if (proformaFilters.paymentDelay !== undefined && proformaFilters.paymentDelay.length > 0) {
                params.filter.expiration_date = { between: proformaFilters.paymentDelay };
            }
        }

        params.filter = JSON.stringify(params.filter);
        params.limit = action.limit;
        params.sort = JSON.stringify(params.sort);

        const result = yield CustomerApi.downloadAllInvoicesApi(params);
        if (result.status === 202) {
            yield delay(2000);
            yield checkInvoicesFile(params.export_id, action);
        } else {
            const error = yield result.json();

            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(CustomerActions.downloadAllInvoicesErr(error.message, action.invoiceType, action.invoiceAction));
        }
    } catch (e) {
        yield put(CustomerActions.downloadAllInvoicesErr(true, action.invoiceType, action.invoiceAction));
        console.log(e);
    }
}

export function* downloadAllInvoicesWatcher() {
    yield takeLatest(CustomerTypes.DOWNLOAD_ALL_INVOICES, downloadAllInvoicesSaga);
}
// D O W N L O A D   A L L   I N V O I C E S

// C R E A T E   G R O U P E D   I N V O I C E
function* createGroupedInvoiceSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const idCustomer = action.data.customer_id;

    try {
        const result = yield CustomerApi.createGroupedInvoiceApi(action.data);
        if (result.status === 202) {
            yield put(CustomerActions.createGroupedInvoiceRes(true, false));
            yield put(CustomerActions.createGroupedInvoiceRes(false, true));
            yield delay(1000);
            yield put(CustomerActions.createGroupedInvoiceRes(false, false));
            yield put(push(`/crm/customers/view/${idCustomer}`));

            setNotification('success', locale, 'global.success', 'customers.notification.regenerateProformaSuccess');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(CustomerActions.createGroupedInvoiceErr(error.message));
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'customers.notification.regenerateProformaError');
        yield put(CustomerActions.createGroupedInvoiceErr());
    }
}

export function* createGroupedInvoiceWatcher() {
    yield takeLatest(CustomerTypes.CREATE_GROUPED_INVOICE, createGroupedInvoiceSaga);
}
// C R E A T E   G R O U P E D   I N V O I C E

// G E N E R A T E   C R E D I T   N O T E   I N V O I C E
function* generateCreditNoteInvoiceSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const setCreditNoteInvoice = yield CustomerApi.generateCreditNoteInvoiceApi(action.data);

        if (setCreditNoteInvoice.status === 200) {
            yield put(CustomerActions.generateCreditNoteInvoiceRes());
            setNotification('success', locale, 'global.success', 'customers.notification.setCreditNoteInvoiceSuccess');
            yield call(loadCustomerInvoicesSaga, {});
        } else {
            console.log('Dkholl Error for IF');
            const error = yield setCreditNoteInvoice.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(CustomerActions.generateCreditNoteInvoiceErr());
        }
    } catch (e) {
        console.log('Dkholl Error');
        yield put(CustomerActions.generateCreditNoteInvoiceErr());
        setNotification('error', locale, 'global.error', 'customers.notification.setCreditNoteInvoiceError');
        console.log(e);
    }
}

export function* generateCreditNoteInvoiceSagaWatcher() {
    yield takeLatest(CustomerTypes.GENERATE_CREDIT_NOTE_INVOICE, generateCreditNoteInvoiceSaga);
}
// G E N E R A T E   C R E D I T   N O T E   I N V O I C E

function* regenerateProformaSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield CustomerApi.regenarateProformaApi({ order_id: action.data.id });
        if (result.status === 202) {
            yield put(CustomerActions.regenerateProformaRes(action.data.id));

            yield call(loadCustomerProformaSaga, action.data);

            setNotification('success', locale, 'global.success', 'customers.notification.createGroupedInvoiceSuccess');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(CustomerActions.createGroupedInvoiceErr());
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'customers.notification.createGroupedInvoiceError');
        yield put(CustomerActions.createGroupedInvoiceErr());
    }
}

export function* regenerateProformaWatcher() {
    yield takeLatest(CustomerTypes.REGENERATE_PROFORMA, regenerateProformaSaga);
}
// R E G E N E R A T E   P R O F O R M A
